

































































import { Component, Vue } from 'vue-property-decorator';
import axios from 'axios';

@Component({
  components: {}
})
export default class LoginForm extends Vue {

  private email: string = '';
  private password: string = '';
  private code: string = '';

  private isLoading: boolean = false;

  protected async onSubmit() {
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    try {
      const response = await axios.post('auth/session', {
        email: this.email,
        password: this.password,
        otp: this.code
      });

      let isAdmin = false;

      try {
        await axios.get('admin/check', {
          headers: {
            Authorization: 'Bearer ' + response.data.token
          }
        });
        isAdmin = true;
      } catch (e) {
        isAdmin = false;
      }

      await this.$store.dispatch('loginUser', {
        email: this.email,
        token: response.data.token,
        isAdmin
      });

      this.$notify({
        title: 'You have been logged in.',
        type: 'success',
        text: 'As a security precaution, this session will not be stored by your browser and ' +
          'you will need to re-authenticate after the window is closed or refreshed.'
      });

      this.$router.push('/');

    } catch (e) {
      if (e.response.status === 401) {
        this.$notify({ type: 'error',  text: 'The credentials entered are incorrect.' });
      } else if (e.response.status === 409) {
        this.$notify({ type: 'error',  text: 'This 2FA code has already been used. Please wait for the next code.' });
      } else {
        this.$notify({ type: 'error',  text: e.message });
      }
    }

    this.password = '';
    this.code = '';

    this.isLoading = false;
  }
}

